import React, { useState, useEffect, useContext } from 'react';
import { useSiteData } from 'react-static';
import { ThemeContext } from 'styled-components';
// template components
import SectionVideoPlayer from '@nmx/template/dist/componentLibrary/modules/SectionVideoPlayer';
// images
import backgroundImageDesktop from './images/podcast-teaser.webp';
import backgroundImageMobile from './images/podcast-teaser-mobile.webp';

export default () => {
  const { config } = useSiteData();

  const theme = useContext(ThemeContext);
  const largeDown = theme.largeDown();
  const [isLargeDown, setIsLargeDown] = useState(largeDown);

  useEffect(() => {
    if (largeDown !== isLargeDown) {
      setIsLargeDown(largeDown);
    }
  }, [largeDown, isLargeDown]);

  return (
    <SectionVideoPlayer
      backgroundImage={isLargeDown ? backgroundImageMobile : backgroundImageDesktop}
      config={config}
      playButtonSupportiveText='Watch the trailer'
      duration='59s'
      durationDisplay='1 min'
      sectionId='podcast-video'
      videoId='hlUY3_-1ltQ'
      videoTitle='See what our podcast is about'
      title='See what our podcast is about'
    />
  );
};
